module.exports = __webpack_public_path__ + "media/images/vp/icon.award.red-8e3b51ee08877cec446d8a2303476db6.svg";